module.exports = __webpack_public_path__ + "img/ptraffic_3.e203beac.jpg";